// Google's Website Translator widget rewrites text nodes directly in the DOM
// (wrapping them in <font> tags, splitting/merging text nodes) without going
// through React. When React later reconciles that same subtree - e.g. toggling
// the wizard's "More options" section right after switching language - it
// tries to remove/insert child nodes that no longer match what Google
// Translate left behind, and the browser throws:
//   "Failed to execute 'removeChild' on 'Node': the node to be removed is
//    not a child of this node" (or the equivalent 'insertBefore' error)
// which is an uncaught DOM exception that crashes the whole React tree.
// This patches the two DOM methods React uses for reconciliation so a
// mismatch caused by Google Translate is silently ignored instead of
// throwing - the standard community workaround for this well-known
// React + Google Translate incompatibility.
const patchNodeMethod = (methodName) => {
    const original = Node.prototype[methodName];
    if (!original || original.__patchedForGoogleTranslate) return;

    const patched = function (...args) {
        try {
            return original.apply(this, args);
        } catch (error) {
            const isNodeMismatch =
                error instanceof DOMException && (error.name === 'NotFoundError' || error.code === 8);
            if (isNodeMismatch) {
                return args[0];
            }
            throw error;
        }
    };
    patched.__patchedForGoogleTranslate = true;
    Node.prototype[methodName] = patched;
};

export const patchDomForGoogleTranslate = () => {
    if (typeof Node === 'undefined') return;
    patchNodeMethod('removeChild');
    patchNodeMethod('insertBefore');
};
